export default {
  path: 'drug-condition',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'DrugConditionList',
      component: () => import('@/views/settingSystem/pages/drug-condition/DrugConditionList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'DrugConditionCreate',
      component: () => import('@/views/settingSystem/pages/drug-condition/DrugConditionCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'DrugConditionEdit',
      component: () => import('@/views/settingSystem/pages/drug-condition/DrugConditionEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
